/** The word for a count: pluralize(1, "record") is "record", pluralize(2, "record") is "records". */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return count === 1 ? singular : plural;
}
